var _style, _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFellowIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#6F52EA;stroke-width:12.0462;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st1{fill:none;stroke:#6F52EA;stroke-width:11.1208;stroke-linecap:round;stroke-miterlimit:10;}\r\n\t.st2{fill:#6F52EA;}\r\n\t.st3{fill:none;stroke:#6F52EA;stroke-width:12.0462;stroke-miterlimit:10;}\r\n\t.st4{fill:none;stroke:#6F52EA;stroke-width:10.0222;stroke-miterlimit:10;}\r\n\t.st5{fill:none;stroke:#6F52EA;stroke-width:9.3806;stroke-miterlimit:10;}\r\n\t.st6{fill:#6F52EA;stroke:#6F52EA;stroke-width:3.928;stroke-miterlimit:10;}\r\n\t.st7{font-family:'Comfortaa-Regular';}\r\n\t.st8{font-size:65.2848px;}\r\n\t.st9{font-size:66.0373px;}\r\n\t.st10{font-size:70.8851px;}\r\n\t.st11{font-size:73.0524px;}\r\n\t.st12{fill:none;stroke:#6F52EA;stroke-width:9.8697;stroke-miterlimit:10;}\r\n\t.st13{fill:none;stroke:#6F52EA;stroke-width:9.8347;stroke-miterlimit:10;}\r\n\t.st14{fill:none;stroke:#6F52EA;stroke-width:8.8936;stroke-miterlimit:10;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M120.1,11.9c0,0,73.82-10.76,117.64,36.91s38.45,106.11,36.14,110.72"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M23.33,89.19c-4.61,9.77-8.01,20.58-9.43,32.41c-7.75,64.29,30.73,108.59,35.3,110.99"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 57.24,
    cy: 53.72,
    r: 45.43
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M78.71,49.59H62.17V33.06c0-2.71-2.19-4.9-4.9-4.9c-2.71,0-4.9,2.19-4.9,4.9v16.53H35.84 c-2.71,0-4.9,2.19-4.9,4.9s2.19,4.9,4.9,4.9h16.53v16.53c0,2.71,2.19,4.9,4.9,4.9c2.71,0,4.9-2.19,4.9-4.9V59.39h16.53 c2.71,0,4.9-2.19,4.9-4.9S81.41,49.59,78.71,49.59z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st3",
    cx: 138.3,
    cy: 117.16,
    r: 27.78
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M138.3,207.63l-61.13-0.1c0.06-33.49,27.63-61.02,61.13-61.02c33.53,0,61.13,27.59,61.13,61.13H138.3z"
  })), /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 108.89,
    cy: 453.89,
    r: 40.37
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 153.1382 393.6543)",
    className: "st6 st7 st8"
  }, "T")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(0.9752 0 0 1 198.6528 393.8916)",
    className: "st6 st7 st9"
  }, "A")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 251.9004 395.5107)",
    className: "st6 st7 st10"
  }, "X")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1.6824 0 0 1 306.2852 396.1621)",
    className: "st2 st7 st11"
  }, "I")), /*#__PURE__*/React.createElement("rect", {
    x: 12.13,
    y: 415.88,
    className: "st2",
    width: 67.41,
    height: 9.48
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M415.48,415.88c3.62,2.63,6.8,5.82,9.37,9.48h68.87v-9.48H415.48z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M368.21,415.88H173.22c-2.62,0-4.74,2.12-4.74,4.74s2.12,4.74,4.74,4.74h185.62 C361.41,421.7,364.59,418.5,368.21,415.88z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M434.74,460.48h26.85c17.75,0,32.14-14.39,32.14-32.14v-26.7c0-46.91-38.03-84.94-84.94-84.94H36.61 c-14.65,0-26.53,11.88-26.53,26.53v93.04c0,13.38,10.84,24.22,24.22,24.22h34.44c-0.14-1.39-0.22-2.8-0.22-4.23 c0-22.29,18.07-40.37,40.37-40.37s40.37,18.07,40.37,40.37c0,1.43-0.08,2.84-0.22,4.23H354"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M278.98,235.95H135.03c-44.59,0-80.74,36.15-80.74,80.74v0h314.48l-18.65-36.96 C336.57,252.89,309.06,235.95,278.98,235.95z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M275.4,235.95h-48.1v-29c0-13.28,10.77-24.05,24.05-24.05h0c13.28,0,24.05,10.77,24.05,24.05V235.95z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M153.14,294.58L153.14,294.58c-3.27,0-5.92-2.65-5.92-5.92V234.8h11.84v53.86 C159.06,291.93,156.41,294.58,153.14,294.58z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M245.15,318.61L245.15,318.61c-3.27,0-5.92-2.65-5.92-5.92V234.8h11.84v77.89 C251.07,315.96,248.42,318.61,245.15,318.61z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st5",
    cx: 391.62,
    cy: 453.89,
    r: 40.37
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFellowIcon);
export default __webpack_public_path__ + "static/media/fellow-icon.f58dce0b0243289cea8cb1a7a185c924.svg";
export { ForwardRef as ReactComponent };